import _merge from 'lodash/merge';
import login, { initializeLogin } from './login';
import isVerified, { initializeIsVerified } from './isVerified';
import onboardingStep, { initializeOnboardingStep } from './onboardingStep';
import mappedProfiles, { initializeMappedProfiles } from './mappedProfiles';
import artists, { initializeArtists } from './artists';
import currentUser, { initializeCurrentUser } from './currentUser';
import accountToRecover, { initializeAccountToRecover } from './accountToRecover';
import returningUserRoles, { initializeReturningUserRoles } from './returningUserRoles';
import saveUsername, { initializeSaveUsername } from './saveUsername';
import primaryAccountId, { initializePrimaryAccountId } from './primaryAccountId';
import updateLegacyProfileToken, { initializeUpdateLegacyProfileToken } from './updateLegacyProfileToken';

export const resolvers = _merge(
  login.resolvers,
  isVerified.resolvers,
  onboardingStep.resolvers,
  mappedProfiles.resolvers,
  artists.resolvers,
  currentUser.resolvers,
  accountToRecover.resolvers,
  returningUserRoles.resolvers,
  saveUsername.resolvers,
  updateLegacyProfileToken.resolvers,
  primaryAccountId.resolvers
);

export const initializeState = cache => {
  initializeLogin(cache);
  initializeIsVerified(cache);
  initializeOnboardingStep(cache);
  initializeMappedProfiles(cache);
  initializeArtists(cache);
  initializeCurrentUser(cache);
  initializeAccountToRecover(cache);
  initializeReturningUserRoles(cache);
  initializeSaveUsername(cache);
  initializeUpdateLegacyProfileToken(cache);
  initializePrimaryAccountId(cache);
};
